module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-template __donate __limited-edu"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container pd-sm-0"
  }, [_c('div', {
    staticClass: "col-md-push-2 col-md-10 col-lg-push-2 col-md-8"
  }, [_c('h2', {
    staticStyle: {
      "width": "100%",
      "color": "white",
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "product product--inline"
  }, [_c('div', {
    staticClass: "product__block--form"
  }, [_c('div', {
    staticClass: "radius block shadow"
  }, [_c('product-donate-choice', {
    ref: "donateChoice",
    attrs: {
      "show-donate-type": true,
      "product": _vm.product,
      "classes": "col-1-5"
    },
    model: {
      value: (_vm.product.price),
      callback: function($$v) {
        _vm.$set(_vm.product, "price", $$v)
      },
      expression: "product.price"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mt-15 mb-15"
  }, [_c('div', {
    staticStyle: {
      "background-color": "#ccc"
    }
  }, [_vm._v("\n                คงเเหลือ " + _vm._s(_vm.remainingBalance) + "\n                จำนวนของ " + _vm._s(_vm.totalRewardItems) + "\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "form__wrapper mt-15 mb-15"
  }, [_c('div', {
    staticClass: "form__section"
  }, [_c('label', {
    staticClass: "form__radio-lg"
  }, [_vm._v("\n                  ไม่ต้องการรับของ\n                  "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attributes.info.rewardProduct),
      expression: "attributes.info.rewardProduct"
    }],
    attrs: {
      "type": "radio",
      "name": "optionsRadios",
      "value": ""
    },
    domProps: {
      "checked": _vm._q(_vm.attributes.info.rewardProduct, "")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.attributes.info, "rewardProduct", "")
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])]), _vm._v(" "), _vm._l((_vm.itemInfos), function(item, idx) {
    return _c('div', {
      key: item.name
    }, [_c('div', {
      staticClass: "form__section"
    }, [_c('label', {
      staticClass: "form__radio-lg",
      class: {
        disable: _vm.isRewardDisabled
      }
    }, [_vm._v("\n                    " + _vm._s(item.name) + " "), _c('small', [_vm._v(_vm._s(_vm.itemPrices[idx]))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.attributes.info.rewardProduct),
        expression: "attributes.info.rewardProduct"
      }],
      attrs: {
        "type": "radio",
        "name": "optionsRadios",
        "disabled": _vm.isRewardDisabled
      },
      domProps: {
        "value": item.value,
        "checked": _vm._q(_vm.attributes.info.rewardProduct, item.value)
      },
      on: {
        "change": function($event) {
          return _vm.$set(_vm.attributes.info, "rewardProduct", item.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "checkmark"
    })])]), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "slide-down"
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.attributes.info.rewardProduct === item.value),
        expression: "attributes.info.rewardProduct === item.value"
      }],
      staticClass: "slide-down-wrapper",
      class: {
        disable: _vm.product.price < Math.max.apply(null, _vm.itemPrices)
      }
    }, [_c('div', {
      staticClass: "form__section block-third slide-down-item"
    }, [_c('div', {
      staticClass: "form__item--lmt-deu"
    }, [_c('div', {
      staticClass: "col-12 col-md-9"
    }, [_c('div', {
      staticClass: "active-image",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.showImage(_vm.itemImages[idx][_vm.activeImages[idx]].large)
        }
      }
    }, [_c('img', {
      staticClass: "ma-auto d-block pd-15",
      attrs: {
        "src": _vm.itemImages[idx][_vm.activeImages[idx]].thumb,
        "alt": "Limited Education",
        "width": "90%"
      }
    })]), _vm._v(" "), _vm._l((_vm.itemImages[idx]), function(item, mIdx) {
      return _c('div', {
        key: mIdx,
        staticClass: "thumbnails d-flex"
      }, [_c('div', {
        staticClass: "img-thumbnail",
        class: idx === _vm.activeImages[idx] ? 'active' : '',
        on: {
          "click": function($event) {
            return _vm.$set(_vm.activeImages, idx, mIdx)
          }
        }
      }, [_c('img', {
        attrs: {
          "src": item.thumb,
          "alt": ""
        }
      })])])
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "col-12 col-md-3"
    }, [_c('div', [_vm._v("เลือกจำนวน")]), _vm._v(" "), _c('div', {
      staticClass: "d-flex"
    }, [_c('div', {
      staticClass: "btn btn--inline btn--sm",
      on: {
        "click": function($event) {
          return _vm.dec(_vm.itemCounts, 0)
        }
      }
    }, [_vm._v("-")]), _vm._v(" "), _c('div', {
      staticClass: "ma-10"
    }, [_vm._v(_vm._s(_vm.itemCounts[0]))]), _vm._v(" "), _c('div', {
      staticClass: "btn btn--inline btn--sm",
      on: {
        "click": function($event) {
          return _vm.inc(_vm.itemCounts, 0)
        }
      }
    }, [_vm._v("+")])])])])])])])], 1)
  })], 2), _vm._v(" "), _c('donor-info', {
    staticClass: "pt-15",
    model: {
      value: (_vm.attributes.info.name),
      callback: function($$v) {
        _vm.$set(_vm.attributes.info, "name", $$v)
      },
      expression: "attributes.info.name"
    }
  }), _vm._v(" "), _c('page-selector', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "product": _vm.product
    },
    model: {
      value: (_vm.attributes.page),
      callback: function($$v) {
        _vm.$set(_vm.attributes, "page", $$v)
      },
      expression: "attributes.page"
    }
  }), _vm._v(" "), _c('product-cart-action', {
    ref: "cartAction",
    style: ({
      margin: 0
    }),
    attrs: {
      "product": _vm.product,
      "attributes": _vm.attributes,
      "initialQuantity": 1,
      "addToCartButton": false,
      "buyNowButton": false
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn--purple btn--default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.donate.apply(null, arguments)
      }
    }
  }, [_vm._v("บริจาค")])])], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "text-center mb-20",
    attrs: {
      "data-v-1f20e9ef": ""
    }
  }, [_c('img', {
    staticClass: "pd-15 ma-auto d-block",
    attrs: {
      "src": "/static/img/limited-edu/logo-lmt-01.png",
      "alt": "Limited Education",
      "width": "260px"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05dba750","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/templates/products/limited-education-2021-group3.vue
// module id = 1108
// module chunks = 0